/** 钱包与网关金额的显示刻度：与后端一致，单位为 1e-8 元。 */
const UNITS_PER_YUAN = 100_000_000;

/**
 * 把 1e-8 元整数单位格式化为元。
 *
 * 保留最少两位小数并去掉末尾多余的零，低于 1 分的扣费仍然可见，
 * 不会被显示成 0.00 而让人误以为没有扣费。
 */
export function formatUnits(units: number): string {
  if (!Number.isSafeInteger(units)) return '0.00';
  const negative = units < 0;
  const magnitude = BigInt(Math.abs(units));
  const whole = magnitude / BigInt(UNITS_PER_YUAN);
  const fraction = (magnitude % BigInt(UNITS_PER_YUAN)).toString().padStart(8, '0').replace(/0+$/, '');
  return `${negative ? '-' : ''}${whole}.${fraction.padEnd(2, '0')}`;
}
